let project = window.fe.project
const feedback = {
  uploadApi: {
    url: `/${project}/upload/publicUploadImg?needResize=true`
  },
  // 规则判断
  getConfig: {
    type: 'get',
    url: `/${project}/rule/execute/stringValue`,
    parameter: {
      key: String
    }
  }
}
if (window.fe.project === 'mall') {
  feedback.uploadApi.url = '/mall/apply/publicUploadImg'
}
export default feedback
